import React, { useEffect, useState, useRef  } from "react"
import './discover.css';

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as BackIcon } from "../../assets/svg/navigation-prev.svg";
import RoomImage from "../../assets/png/room-image.png";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { format, parse } from 'date-fns';
import { apiCall } from '../../services/api-service';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Header from "../common/Header";
import { useGlobal } from "../../GlobalContext.js";
export default function Reschedule(){
   const { selectedMenu, setSelectedMenu } = useGlobal();

   const navigate = useNavigate();
    const location = useLocation();
    const { id, date,formatted_date, } = location.state || {};
    const scrollRefs = useRef();

  const scrollLeft = () => {
    const ref = scrollRefs.current;
    if(ref){
    ref.scrollBy({ left: -100, behavior: "smooth" }); 
    }
  };

  const scrollRight = () => {
    const ref = scrollRefs.current;
    if(ref){
        ref.scrollBy({ left: 100, behavior: "smooth" }); 
    }
  };
  
  const [selectedOffice, setOfficeValue] = useState('');
  const [selectedFloor, setFloorValue] = useState('');
  const handleDropdownChange = (value) => {
    setOfficeValue(value); 
   
  };
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedDateFormat, setSelectedDateFormat] = useState('');
 function formatDate2(inputDate) {
  try{
    if(inputDate!==undefined){
           // Parse the input date (MM/DD/YYYY format)
           const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
         
           
           // Format the date
           return format(parsedDate, "yyyy-MM-dd");
          }else{
            return "";
          }
          } catch (err) {
            console.error("Error fetching options:", err);
           
          } finally {
            
          }
         }
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedDateFormat(formatDate2(date.toLocaleDateString()));
    setShowPicker(false);
  };
  const [showPicker, setShowPicker] = useState(false);


  const [meetingRoomDetails, setMeetingRoom] = useState({});
  const [selectedSlotPeriod, setSelectedSlotPeriod] = useState('');
  const [selectedPeriodFrom, setSelectedPeriodFrom] = useState('');
  const [selectedPeriodTo, setSelectedPeriodTo] = useState('');
 const [errorMessage, setErrorMessage] = useState(''); 
  const [selectedCategory, setCategoryValue] = useState('');
    const [selectedSlot, setSlotValue] = useState('30 mins');
    const [selectedBookId, setBookId] = useState([]);
   
      const [categoryList, setCategory] = useState([]);

      const [floorList, setFloors] = useState([]);
      const [roomList, setRooms] = useState([]);
      const [isOpen, setIsOpen] = useState(false);
       const [loading, setLoading] = useState(false);
            const [error, setError] = useState(null);

      const openModal = (id) =>{
       
        setIsOpen(true);
      };
      const closeModal = () => setIsOpen(false);
      const [selectedRoomId, setRoomId] = useState(-1);
      const [selectedRoomIndex, setRoomIndex] = useState(-1);
     const [availableList, setAvailable] = useState(['Ac','Projector','TV & Speaker']);
     const [slotList, setSlotList] = useState([]);
     const [startTimeInputValue, setStartTimeInputValue] = useState("");
          const [endTimeInputValue, setEndTimeInputValue] = useState("");
          const [startTime12HourInputValue, setStartTime12HourInputValue] = useState("");
          const [endTime12HourInputValue, setEndTime12HourInputValue] = useState("");
const [customSlotErrorMessage, setCustomSlotErrorMessage] = useState({date:'',  from:'',  to:'',} );

 const alertRef = useRef(null);
      const handleClickOutside = (event) => {
        if (alertRef.current && !alertRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
 useEffect(() => {
          // Attach event listener to the document
          document.addEventListener("mousedown", handleClickOutside);
          return () => {
            // Clean up event listener on unmount
            document.removeEventListener("mousedown", handleClickOutside);
          };
        }, []);

      const menuBoxInactive = {width:'128px',height:'44px', display:'flex',justifyContent:"center", alignItems:"center",};
      const menuBoxActive = {width:'128px',height:'44px', display:'flex',justifyContent:"center", alignItems:"center",borderBottom: "3px solid #842234",};
      const menuColorActive = {fontSize:"15px", fontWeight:"700",lineHeight:"17.17px", color: '#842234',};
      const menuColorInactive = {fontSize:"15px", fontWeight:"400",lineHeight:"17.17px", color: '#1E1E1E',};
      const profileName = {fontSize:"14px", fontWeight:"700", color: '#842234',}; 
      const title = {fontSize:"32px", fontWeight:"700", color: '#1E1E1E',};
      const subtitle = {fontSize:"15px", fontWeight:"400", color: '#81878C',};
      const roomTitle = {fontSize:"18px", fontWeight:"500", color: '#1E1E1E',};
      const seatCount = {fontSize:"13.5px", fontWeight:"400", color: '#81878C',marginTop:'8px',};
      const availableTitle = {fontSize:"12px", fontWeight:"400", color: '#81878C',marginBottom:'8px',};
      const availableName = {fontSize:"12.5px", fontWeight:"400", color: '#21272C'};
      const slotTitle = {fontSize:"13px", fontWeight:"700", color: '#1E1E1E'};
      const slotTitleSelected = {fontSize:"12px", fontWeight:"500", color: '#842234'};
      const filterTitle = {fontSize:"24px", fontWeight:"700", color: '#1E1E1E'};
      const officeTitle = {marginTop:'16px',marginBottom:'8px',fontSize:"15px", fontWeight:"700",lineHeight:"17.17px", color: '#1E1E1E',};
      const modalStyle = {
        overlay: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          opacity:0.8,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        },
        modal: {
          backgroundColor: "#ffffff",
          padding: "16px 24px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          width: "328px",
          height:"229px",
          textAlign: "center",
        },
      };
      
      
        const handleCategoryClick = (category) => {
            setCategoryValue(category);
           
        };
       
        function formatDate(inputDate) {
          try{
            if(inputDate!==undefined){
          // Parse the input date (MM/DD/YYYY format)
          const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
        
          // Format the date
          return format(parsedDate, "EEEE, dd MMM yyyy");
        }else{
          return "";
        }
        } catch (err) {
          console.error("Error fetching options:", err);
         
        } finally {
          
        }
        }

        useEffect(() => {
          setSelectedMenu("Discover");
          const initialDate = date ? (typeof date === 'string' && date.includes('T') ? date.split('T')[0] : date) : format(new Date(), "yyyy-MM-dd");
          setSelectedDateFormat(initialDate);
          setSelectedDate(initialDate);
          fetchOptions();
        },[]); 
useEffect(() => {  
          if(selectedSlot!=='custom'){
            getSlots();
          }else{
            getCustomSlots();
          }      
         
        },[selectedDate]);

        useEffect(() => {          
          getSlots();
        },[meetingRoomDetails]); 
        useEffect(() => {          
          getSlots();
        },[selectedSlot]); 

        const fetchOptions = async () => {
          setLoading(true);
          setError(null);
         
          try {
            const response = await apiCall("get", `booking/${id}`);
        
          if(response.data.success===true){
            console.log("booking:", response.data.booking);
            setMeetingRoom(response.data.booking??{});  
            setAvailable(response.data.booking?.available ?? []);  
                 
        }
        console.log("Room List:", roomList);
        console.log("Room List Length:", roomList.length);
          } catch (err) {
            console.error("Error fetching options:", err);
            setError("Failed to fetch options. Try again.");
          } finally {
            setLoading(false);
          }
        };
  
        const getSlots = async () =>   {
          console.log('meeting_room_id..............',meetingRoomDetails["meeting_room_id"])
          setErrorMessage("");
          try {
            console.log("get_slots api called");
            const formattedDate = selectedDateFormat || (typeof selectedDate === 'string' ? selectedDate : (selectedDate ? format(new Date(selectedDate), "yyyy-MM-dd") : ""));
            const data={
              "office_id": selectedOffice,
              "floor": selectedFloor,
              "date": formattedDate, 
              "from": "",
              "to": "",
              "id": [meetingRoomDetails["meeting_room_id"]],
              "range": selectedSlot
            };
            const response = await apiCall("post", "get_slots", data);
            if (response?.status === 500) {
              setErrorMessage(response.data?.message);
            } else if (response?.data?.success === true) {
              const index = response.data.data
                .findIndex(element => element.id === meetingRoomDetails["meeting_room_id"]);

              if (index > -1) {
                console.log('slots', response.data.data[index]["slots"]);
                setSlotList(response.data.data[index]["slots"]);
              }
              await new Promise((resolve) =>
                setTimeout(() => resolve(), 1000)
              );
              const today = new Date().toISOString().split('T')[0];
              const selected = new Date(selectedDate).toISOString().split('T')[0];
              console.log('date today',today);
              console.log('date selected',today);
              if(today === selected){
                var slotIndex=-1;
                if(response.data.data.length>0){
                  const now = new Date();
                  const hours = now.getHours().toString().padStart(2, '0');
                  const minutes = now.getMinutes().toString().padStart(2, '0');
                  response.data.data[0]["slots"].some((slot, index) => {
                    console.log('current time.....',`${hours}:${minutes}`)
                    console.log('slot time.....',slot["from"])
                    const isCurrentTime=  compareTimes(slot["from"],slot["to"],`${hours}:${minutes}`);
                    console.log('isCurrentTime.....',isCurrentTime)
                    if (isCurrentTime === true) {
                      slotIndex=  index;
                      return true;
                    }
                    return false;
                  });
                }
                console.log('date equal');
                response.data.data.forEach(async() => {
                  console.log('ref slotIndex',slotIndex)
                  console.log('ref Index',index)
                  const ref = scrollRefs.current;
                  if(ref){
                    console.log('ref exist')

                    ref.scrollTo({
                      left: 0,
                      behavior: 'smooth',
                    });
                    await new Promise((resolve) =>
                      setTimeout(() => resolve(), 500)
                    );
                    ref.scrollBy({ left: 126 * (slotIndex+1), behavior: "smooth" });
                  }
                });
              }
            }
              
          } catch (err) {
            console.error("Error fetching options:", err);
            setError("Failed to fetch options. Try again.");
          } finally {
            setLoading(false);
          }
       
        };
    useEffect(() => {
             if(startTimeInputValue!=="" && endTimeInputValue!==""){
               getCustomSlots();
             }         
           },[startTimeInputValue,endTimeInputValue]); 

           const getCustomSlots = async () =>   {
            setErrorMessage("");
            setCustomSlotErrorMessage({date:'',  from:'',  to:'',});
            try {
              console.log("get_slots api called");
              const formattedDate = selectedDateFormat || (typeof selectedDate === 'string' ? selectedDate : (selectedDate ? format(new Date(selectedDate), "yyyy-MM-dd") : ""));
              const data={
                "room_id": meetingRoomDetails["meeting_room_id"],
                "date": formattedDate, 
                "from": startTimeInputValue.slice(0, 5),
                "to": endTimeInputValue.slice(0, 5),
                repeat_booking: false,
              };
              const response = await apiCall("post", "check_slot_availability", data);
              if (response?.status === 400) {
                var errorMsg= response.data?.error;
                setErrorValue(response.data?.error ?? {});
                console.log('error msg',errorMsg)
                setSelectedSlotPeriod("");
                setSelectedPeriodFrom("");
                setSelectedPeriodTo("");
              } else if (response?.status === 500) {
                setErrorMessage(response.data?.message);
                setSelectedSlotPeriod("");
                setSelectedPeriodFrom("");
                setSelectedPeriodTo("");
              } else if (response?.data?.success === true) {
                if (response.data.available === true) {
                  setErrorMessage('');
                  setSelectedSlotPeriod(startTime12HourInputValue +' - '+endTime12HourInputValue);
                  setSelectedPeriodFrom(startTimeInputValue.slice(0, 5));
                  setSelectedPeriodTo(endTimeInputValue.slice(0, 5));
                } else {
                  setErrorMessage('Slot not available');
                  setSelectedSlotPeriod('');
                  setSelectedPeriodFrom('');
                  setSelectedPeriodTo('');
                }
              }
               
            } catch (err) {
              console.error("Error fetching options:", err);
              setError("Failed to fetch options. Try again.");
            } finally {
              setLoading(false);
            }
         
          };
          const setErrorValue = async (errorMsg) =>   {
            setCustomSlotErrorMessage({
              date:errorMsg['date']!==undefined?errorMsg['date'][0]:'',
              from:errorMsg['from']!==undefined?errorMsg['from'][0]:'',
              to:errorMsg['to']!==undefined?errorMsg['to'][0]:'',           
            }); 
            
          }

        const rescheduleBookingRoom = async () =>   {
          setErrorMessage('');
          console.log("get_slots api called");
          const data={
            "date": selectedDateFormat || (typeof selectedDate === 'string' ? selectedDate : (selectedDate ? format(new Date(selectedDate), "yyyy-MM-dd") : "")),
            "from": selectedPeriodFrom,
            "to": selectedPeriodTo,
          };

          const response = await apiCall("put", `reschedule_booking/${id}`, data);
          console.log("Response status:", response.status);
          console.log("Response data:", response.data);
          if(response.status===200){
            if (response.data.success === true) {
              navigate(-1);
            }
          } else if (response.status===500){
            setErrorMessage(response.data?.message);
          }
          
             
          
        
     
      };
   
      function convertTo12HourFormat(time24) {
        // Split the time string into hours and minutes
        const [hours24, minutes] = time24.split(":");
      
        // Convert to a number and calculate 12-hour format
        const hours = parseInt(hours24, 10) % 12 || 12; // Convert 0 to 12 for midnight
        const period = parseInt(hours24, 10) >= 12 ? "PM" : "AM";
      
        // Return formatted time
        return `${hours}:${minutes} ${period}`;
      }
      const compareTimes = (fromTime,toTime, currentTime) => {
        // Split the times into hours and minutes
        const [hours1, minutes1] = fromTime.split(':').map(Number);
        const [hours2, minutes2] = toTime.split(':').map(Number);
        const [hours3, minutes3] = currentTime.split(':').map(Number);
      
        // Convert both times to total minutes
        const totalFromMinutes = (hours1 * 60) + minutes1;
        const totalToMinutes = (hours2 * 60) + minutes2;
        const totalCurrentMinutes = (hours3 * 60) + minutes3;
        // Compare the total minutes
       if (totalFromMinutes < totalCurrentMinutes && totalToMinutes>totalCurrentMinutes) {
          return true; 
        } else {
          return false; 
        }
      };
    return  (<Container fluid className="GTWalsheimTrial">
      
              {/* <Header selectedTab={'Discover'}/>   */}
              <Row className="flex-wrap" style={{height:'calc(100vh - 68px)',overflow: 'auto',scrollbarWidth: "none",msOverflowStyle: "none",justifyContent:'center',}}>
             
        <Col  xl={8} style={{padding: '16px', justifyContent:'center',}}> 
        <div style={{display: 'flex', alignItems: 'center', justifyContent:'start',}}>
        <div onClick={() => navigate("/")} style={{cursor: "pointer", fontSize:"13px", fontWeight:"400", color: '#1e1e1e'}} >
            Discover
            </div> &nbsp;&nbsp; <ArrowNextIcon/>&nbsp;&nbsp;
            <div onClick={() => navigate("/discover-view", { state: { id: meetingRoomDetails["meeting_room_id"] } })} style={{cursor: "pointer", fontSize:"13px", fontWeight:"500", color: '#842234'}} >
            {meetingRoomDetails['room']??''}
            </div>
            </div>
            &nbsp;&nbsp;
            
            <div style={{fontSize:"16px", fontWeight:"800", color: '#1E1E1E'}} >
            Office & Room details
            </div>
            
            <Col key= {`room`}  style={{marginTop:'16px',paddingTop:'24px',paddingBottom:'24px',paddingRight:'16px',paddingLeft:'16px', background: '#ffffff', borderRadius:'24px', }}>
               {/* <Row md={12} className="justify-content-between"> */}
               <div style={{display: 'flex', justifyContent:'space-between'}}>
               <div style={{display: 'flex',alignItems:'center',justifyContent:'start'}}>
              <div style={{width:'36px', height:'36px',borderRadius: "100px", }}>
              <img  src={meetingRoomDetails['org_image']!=null && meetingRoomDetails['org_image']!=''?meetingRoomDetails['org_image']: RoomImage}    alt="org" style={{ width:'36px', height:'36px', borderRadius:'100px' }} />
              </div>
              <div style={{marginLeft:'8px'}}>
              <div style={{fontSize:"16px", fontWeight:"700", color: '#1E1E1E'}} >
              {meetingRoomDetails['office']??''}
            </div>
            <div style={{fontSize:"13px", fontWeight:"500", color: '#842234',}} >
            {meetingRoomDetails['floor_label']??''}
            </div>
              </div>
              </div>
              
              </div>
              <div style={{padding: "16px", marginTop:'16px',  borderRadius: "24px", background: '#F6F7F9'}}>
            <div style={{display: 'flex',}}>
            
              <img src={meetingRoomDetails['image']!=null && meetingRoomDetails['image']!==''?meetingRoomDetails['image']: RoomImage} alt="room" style={{ width: '36px', height: '36px', borderRadius:'6px' }} />
              <div style={{marginLeft:'16px'}}>
            <div style={{fontSize:"15px", fontWeight:"500", color: '#1E1E1E'}} >
            {meetingRoomDetails['room']??''}
            </div>

            <div style={{display: 'flex', alignItems: 'center', justifyContent:'start',}}>
        <div style={{fontSize:"13px", fontWeight:"400", color: '#1E1E1E', opacity:0.6,}} >
        {meetingRoomDetails['capacity']??'0'} Seater
            </div> &nbsp;&nbsp; <div style={{width:'3px',height:'3px', backgroundColor:'#D9D9D9'}}></div>&nbsp;&nbsp;
            <div style={{fontSize:"14px", fontWeight:"400", color: '#81878C'}} >
            {meetingRoomDetails['category']??''}
            </div>
            </div>
           </div>
            </div>
            
            
           
            </div>
    {/* </Row> */}
            </Col >

           
           
            &nbsp;&nbsp;
            <div style={{fontSize:"16px", fontWeight:"800", color: '#1E1E1E'}} >
            Schedule Date & Time
            </div>
            <div style={{marginTop:'16px',padding: "16px",borderRadius: "24px", background: '#ffffff'}}>
            <div style={{fontSize:"20px", fontWeight:"700", color: '#1E1E1E'}} >
            Choose date
            </div>
            <input id="selected_date"
                        type="date" value={selectedDate || ''} onChange={(event) => { setSelectedDate(event.target.value); setSelectedDateFormat(event.target.value); }}
                        style={{
                          height: "40px",
                          borderRadius: "10px",
                          border: "0.7px solid #E5E5E5",
                          padding: "16px",
                        }}
                        className="date-picker w-100"
                        placeholder="DD-MM-YYYY"
                      />
             {/*  <div style={{marginTop:'8px', position: 'relative',  height:"40px" }}>
                    
                    <div style={{ display: 'flex', alignItems: 'center', border: '0.7px solid #E5E5E5', borderRadius: '8px', padding: '10px 12px' }}>
                      <input
                        type="text"
                        value={selectedDate ?formatDate(selectedDate.toLocaleDateString()) : ''}
                        onClick={() => setShowPicker(!showPicker)}
                        readOnly
                        style={{ flex: 1, border: 'none', outline: 'none', cursor: 'pointer' }}
                        placeholder="Select a date"
                      />
                      <CalendarIcon style={{ cursor: 'pointer', color: '#842234' }} onClick={() => setShowPicker(!showPicker)} />
                    </div>
              
                   
                    {showPicker && (
                      <div style={{ position: 'absolute', top: '40px', zIndex: 100, background: '#fff', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0px 4px 6px rgba(0,0,0,0.1)' }}>
                        <DayPicker mode="single" selected={selectedDate} onSelect={handleDateChange} />
                      </div>
                    )}
                  </div> */}     

                    <Col style={{marginTop:'16px',}}  className="justify-content-start justify-content-sm-start justify-content-md-end" >
             
         <div style={{display: 'flex',alignItems: 'center', justifyContent:'space-between',}}>
        <div style={slotTitle}>Select your slot </div>
       
        <div key="more" style={{ position: "relative" }}>
        <div onClick={() =>openModal(meetingRoomDetails["id"])} style={{cursor: "pointer", width: '79px',height: '28px',  borderRadius: '62px', border: '0.8px solid #842234',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#FFFFFF' }}>
            <div style={slotTitleSelected}>{selectedSlot}</div>&nbsp; <div><ArrowDownIcon/></div>   
            </div>
            {isOpen && (
                                                 <div ref={alertRef} style={{ position: "absolute",
                                                  top: "40px",
                                                  left: "50%",
                                                  transform: "translateX(-50%)",
                                                  backgroundColor: "#ffffff",
                                                  color: "#1E1E1E",
                                                  padding: "16px",
                                                  borderRadius: "16px",
                                                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                                  zIndex: 1,alignItems:'end', }}>
                                                  <div  style={{cursor: "pointer",width:'150px', height:'36px', fontSize:"14px", fontWeight:"500",  color: '#1E1E1E',display: 'flex',alignItems:'center',justifyContent:'start'}} 
                                                  onClick={()=>{
                                                    setSlotValue("30 mins");
                                                    setIsOpen(false);
                                                  }}>
                                                  30 mins slot
                                        </div>
                                        <div   style={{cursor: "pointer",width:'150px',height:'36px', fontSize:"14px", fontWeight:"500", color: '#1E1E1E', display: 'flex',alignItems:'center',justifyContent:'start'}} 
                                        onClick={()=>{
                                          setSlotValue("1 hour");  
                                          setIsOpen(false);                                        
                                        }}>
                                        One hour slot
                                        </div>
                                        <div   style={{cursor: "pointer",width:'150px',height:'36px', fontSize:"14px", fontWeight:"500", color: '#1E1E1E', display: 'flex',alignItems:'center',justifyContent:'start'}} 
                                       onClick={()=>{
                                        setSlotValue("custom"); 
                                        setIsOpen(false);                                       
                                       }} >
                                        Customized time
                                        </div>
                                                 </div>
                                               )}
            </div>
        </div>  
        {selectedSlot!=='custom' && ( <Row  style={{display: 'flex', marginTop:'8px', alignItems: 'center', justifyContent:'space-between',}}>
        <Col   key={`arrow-btn-1`} style={{width: '28px',height: '28px',justifyContent:"end", }}>
        <div  onClick={() =>scrollLeft()}  style={{cursor: "pointer", width: '28px',height: '28px',  borderRadius: '100px', border: '0.5px solid #D4DDE7',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#FFFFFF', color:'#842234' }}>
             <div><ArrowPrevIcon/></div>   
            </div>
            </Col>
            <Col xs={11} ref={scrollRefs} style={{paddingLeft:'8px',display: 'flex',justifyContent:"start", alignItems:"center", whiteSpace: "nowrap", height: '40px',overflowX: "scroll",overflowY: "hidden",scrollbarWidth: "none",    msOverflowStyle: "none", }}>
           
            {slotList.map((slot,slotIndex) => (
          <div onClick={() =>{
            if(slot["expired"]===false && slot["available"]===true){
              setSelectedSlotPeriod(slot["period"]);
              setSelectedPeriodFrom(slot["from"]);
              setSelectedPeriodTo(slot["to"]);             
            }
          }}
          key={`${slotIndex}`} style={{/* width: '120px', */cursor: "pointer", height: '32px',marginRight:'6px',marginBottom:'4px', paddingLeft:'8px',paddingRight:'8px',  borderRadius: '8px',  display:'flex',justifyContent:"center", alignItems:"center", 
            backgroundColor: selectedSlotPeriod===slot["period"]?'#EDFFF5': (slot["available"] === false?'#FFF1F4':(slot["expired"] === true?'#F5F5F5':'#FFFFFF')),
            border: selectedSlotPeriod===slot["period"]?'1px solid #20824A': (slot["available"] === false?'1px solid #E93153':(slot["expired"] === true?'1px solid #E5E5E5':'1px solid #E5E5E5')), }}>
          <div style={availableName}>{slot["period"]}</div>   
         </div>
        ))}           
            </Col>
           <Col   key={`arrow-btn-2`} style={{width: '28px',height: '28px',justifyContent:"start", }}>
            <div  onClick={() =>scrollRight()} style={{cursor: "pointer", width: '28px',height: '28px',  borderRadius: '100px', border: '0.5px solid #D4DDE7',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#FFFFFF', color:'#842234' }}>
             <div><ArrowNextIcon/></div>   
            </div>
            </Col>
            </Row>  )} 

             {selectedSlot==='custom' && (
            <Row>
                          <Col>
                          <div  className="material-form-group">
                          <input
                            type="time"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" "
                            value={startTimeInputValue}
                            onChange={(event) => {
                              setStartTimeInputValue(event.target.value); 
                              setStartTime12HourInputValue(convertTo12HourFormat(event.target.value))
                            }}
                            style={{cursor: "pointer",}}
                          />
                          <label htmlFor="material-input" className="material-label">
                          Start Time
                          </label>
                        </div>
                        { customSlotErrorMessage.from!=="" && (<div  style={{textAlign:'start',}} className="text-muted" >
                                 <div style={{color:'#ff0000'}}>{customSlotErrorMessage.from}</div>
                                  </div>)} 
                                  
                          </Col>
                          <Col>
                          <div  className="material-form-group">
                          <input
                            type="time"
                            id="material-input"
                            className="form-control material-input"
                            placeholder=" "
                            value={endTimeInputValue}
                            onChange={(event) => {
                              setEndTimeInputValue(event.target.value); 
                              setEndTime12HourInputValue(convertTo12HourFormat(event.target.value))
                            }}
                            style={{cursor: "pointer",}}
                          />
                          <label htmlFor="material-input" className="material-label">
                          End Time
                          </label>
                        </div>
                        { customSlotErrorMessage.to!=="" && (<div  style={{textAlign:'start',}} className="text-muted" >
                                 <div style={{color:'#ff0000'}}>{customSlotErrorMessage.to}</div>
                                  </div>)} 
                          </Col>
                         
                        </Row>  
                        )} 
 { errorMessage!=="" && ( <div style={{ fontSize:"14px", fontWeight:"700", color: '#FF4444' }}> {errorMessage}  </div>)} 
           
            
     {/*  {isOpen && (
        <div style={modalStyle.overlay}>
          <div style={modalStyle.modal}>
            <div  style={{color: '#ffffff' }}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent:'space-between',}}>
           <div style={{display: 'flex',alignItems: 'center', justifyContent:'start',}}>
           <SlotFilterIcon/><div style={{ paddingLeft:'4px',fontSize:"20px", fontWeight:"700", color: '#1E1E1E' }}>Change Slot Type</div>
           </div>
           <SlotCloseIcon onClick={closeModal}/>
           </div>
           <div style={{ marginTop:'20px',}}>
           <div onClick={() => {
            console.log(selectedSlot);
            
            setSlotValue("30 mins");
            
           
            closeModal();
          }} style={{height: '46px', display: 'flex', alignItems: 'center', justifyContent:'space-between',}}>
           <div style={{ paddingLeft:'4px',fontSize:"20px", fontWeight:"700", color: '#1E1E1E' }} className="custom-radio">
           30 mins slot
           </div>
           <label>
        <input  key="30mins"
          type="radio"
          name="30mins"
          value="30 mins"
          checked={selectedSlot === "30 mins"?true:false}
        
        />
      </label>
           
           </div>

           <div onClick={() => {
            console.log(selectedSlot);
           
            setSlotValue("1 hour");
           
            closeModal();
          }} style={{height: '46px',display: 'flex', alignItems: 'center', justifyContent:'space-between',}}>
           <div style={{ paddingLeft:'4px',fontSize:"20px", fontWeight:"700", color: '#1E1E1E' }} className="custom-radio">
           One hour slot
           </div>
          
        <label>
        <input key="1hourradio"
          type="radio"
          name="1hourradio"
          value="1 hour"
          checked={selectedSlot === "1 hour"?true:false}
         
        />
      </label>
           </div>

           <div onClick={() => {
            console.log(selectedSlot);
           
            setSlotValue("custom");
            closeModal();
          }} style={{height: '46px',display: 'flex', alignItems: 'center', justifyContent:'space-between',}}>
           <div style={{ paddingLeft:'4px',fontSize:"20px", fontWeight:"700", color: '#1E1E1E' }} className="custom-radio">
           Customized time
           </div>
          
        <label>
        <input key="customradio"
          type="radio"
          name="customradio"
          value="custom"
          checked={selectedSlot === "custom"?true:false}
        
        />
      </label>
           </div>

           
           </div>
          </div>
          </div>
        </div>
      )} */}
    
    </Col> 
            </div>

            <div xs={12} style={{display:'flex'}}>
                    <div  onClick={()=>{
                           navigate(-1);
                        }} className="w-50 mt-3" style={{ height: '36px',marginLeft:'8px',marginRight:'8px', borderRadius: '100px',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#ffffff', border: '1px solid #E5E5E5', }}>
                         <div style={{ fontSize:"14px", fontWeight:"700", color: '#1E1E1E' }}><BackIcon/>&nbsp;Back</div>   
                        </div>
                        <div  onClick={() => {
              if(selectedSlotPeriod!==''){
                rescheduleBookingRoom();
              }
    }} className="w-50 mt-3"  style={{ height: '36px',marginLeft:'8px',marginRight:'8px',  borderRadius: '100px',  display:'flex',justifyContent:"center", alignItems:"center", backgroundColor: '#842234', opacity: selectedSlotPeriod!==''?1:0.7 }}>
                         <div style={{ fontSize:"14px", fontWeight:"700", color: '#F3F6F9' }}>Reschedule</div>   
                        </div>
                        </div>
        </Col>
              </Row>
        </Container>)



}